// extracted by mini-css-extract-plugin
export default {"favorites":"Favorites_favorites__L+-L6","favorites_count":"Favorites_favorites_count__GYot6","favorites_list":"Favorites_favorites_list__zj72U"};